import React from 'react';
import FirstPerson from './FirstPerson'
import SecondPerson from './SecondPerson'

const App = () => {
  return (
    <div>
      <FirstPerson />
      <SecondPerson />
    </div>
  );
}

export default App



// WEBPACK FOOTER //
// ./src/App.js